/**
 * 다이얼로그 레이아웃 토큰 — docs/design/1.1-design-modal-spec-overview.md 와 맞출 것.
 * 화면에서 max-width 등은 가능한 한 여기서만 참조한다.
 */
export const MODAL_MAX_WIDTH = Object.freeze({
  XS: '400px',
  /** 프로필·비밀번호 등 짧은 폼 */
  FORM_COMPACT: '500px',
  SM: '600px',
  MD: '800px',
  /** 담당자 편집 등 (md~lg 사이) */
  MD_WIDE: '850px',
  LG: '1040px',
  XL: '1200px',
  XXL: '1280px',
});

export const MODAL_LAYOUT_SPECIAL = Object.freeze({
  DEFECT_FEEDBACK: '50%',
  REPORT_SUMMARY_WIDTH: '80%',
  REPORT_SUMMARY_MAX_WIDTH: '1000px',
  DRONE_PORT: '290px',
  PROGRESS_INLINE: '300px',
  FILE_DETAIL_MIN_WIDTH: '90%',
  IMAGE_PREVIEW_MIN_WIDTH: '100vw',
  /** AI 중복 검출 제거: IR 2장 나란히 비교 — 열당 최대 600px·2열+여백 반영 가로 상한 */
  AI_THERMAL_COMPARE_MAX: '1240px',
});

/**
 * 닫기 정책 — docs/design/1.1-design-modal-spec-overview.md §2 (P0/P1/P2).
 * ESC·@click:outside 는 각 화면 템플릿에서 유지.
 * Vuetify v-dialog: persistent = 바깥 클릭 닫힘 방지.
 */
const lockedForm = Object.freeze({
  persistent: true,
  noClickAnimation: true,
});

/** 수정/추가 폼 다이얼로그 최대 높이(px) — 노트북 창 기준 초과 시 바깥 스크롤 방지 */
export const MODAL_FORM_MAX_HEIGHT = 'min(915px, calc(100vh - 48px))';

/**
 * 폼·수정 다이얼로그 공통 뷰포트.
 * ExamineReportSummaryDialog, FileDetailDialog(미리보기), ThermalImageComparisonDialog(너비·전용) 등은 제외.
 * v-dialog에 v-bind로 spread: maxHeight + scrollable + contentClass
 */
export const MODAL_FORM_VIEWPORT = Object.freeze({
  maxHeight: MODAL_FORM_MAX_HEIGHT,
  scrollable: true,
  contentClass: 'solvit-dialog-form-shell',
});

/** v-dialog에 한 번만 v-bind — duplicate-attribute 방지 (정책 + 915px 상한) */
export const MODAL_P2_FORM_VIEWPORT = Object.freeze({
  ...lockedForm,
  ...MODAL_FORM_VIEWPORT,
});
export const MODAL_PERSISTENT_ONLY_VIEWPORT = Object.freeze({
  persistent: true,
  ...MODAL_FORM_VIEWPORT,
});
export const MODAL_P1_DISMISSIBLE_VIEWPORT = Object.freeze({
  persistent: false,
  noClickAnimation: true,
  ...MODAL_FORM_VIEWPORT,
});
export const MODAL_NO_CLICK_ANIM_VIEWPORT = Object.freeze({
  noClickAnimation: true,
  ...MODAL_FORM_VIEWPORT,
});

export const MODAL_CLOSE_POLICY = Object.freeze({
  /** P2: 관리 폼·업로드·AI 등 — 바깥 클릭 닫힘 방지 */
  P2_FORM: lockedForm,
  /** P0: 문서상 엄격 모드 — 현재 Vuetify 동작은 P2와 동일 */
  P0_LOCKED: lockedForm,
  /** P1: 바깥 클릭으로 닫기 허용 */
  P1_DISMISSIBLE: Object.freeze({
    persistent: false,
    noClickAnimation: true,
  }),
  /** persistent 만 (클릭 애니 Vuetify 기본) */
  PERSISTENT_ONLY: Object.freeze({ persistent: true }),
  /** 오버레이 클릭 리플만 끔 — 바깥 닫힘은 기본 허용 */
  NO_CLICK_ANIM_ONLY: Object.freeze({ noClickAnimation: true }),
});
